// extracted by mini-css-extract-plugin
export default {"img":"NavigationBar_img__5h0ci","searchInputBox":"NavigationBar_searchInputBox__BKfTs"};